var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-process"},_vm._l((_vm.steps),function(step){return _c('div',{key:step.number},[_c('span',{class:[
        'step',
        { active: step.number == _vm.active, last: step.number == 3 }
      ]},[(step.number >= _vm.active)?_c('span',{staticClass:"number"},[_vm._v(" "+_vm._s(step.number)+" ")]):_c('span',{staticClass:"number"},[_c('span',{staticClass:"check-mark"})]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(step.name))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }